import React from 'react';
import { Box } from 'grommet';
import PropTypes from 'prop-types';
import Form from './Form/Form';
import { PageSection, SectionBody } from './PageSection';

/**
 * A section that displays a form and a title/subtitle
 */

const FormSection = ({ form, onSubmit }) => (
  <PageSection>
    <SectionBody>
      <Box align="center">
        <Box width={{ max: '800px' }}>
          <Form {...form} onSubmit={onSubmit} />
        </Box>
      </Box>
    </SectionBody>
  </PageSection>
);

FormSection.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default FormSection;
